import * as _ from "lodash";
export const validate = async (
  formAttributes,
  formDetails,
  mediaSource,
  errors,
  setUploadErrorPopup,
  setErrorData
) => {
  try {
    formAttributes.map((el) => {
      if (el.attrType === "scoring") {
        el.items.map((data) => {
          let checkKey = el.property[data];
          if (
            el?.required &&
            (_.isEmpty(formDetails[checkKey]) ||
              formDetails[checkKey] === "undefined")
          ) {
            errors[checkKey] = "Please enter this field";
            setErrorData({
              // error: `Please Fill Out Required Fields`,
              description: `Please make sure to complete all mandatory questions before proceeding. Thank you!"`,
            });
            setUploadErrorPopup(true);
          }
        });
      }
      if (el.attrType === "prediction") {
        let checkKey = el.property["key"];
        if (
          el?.required &&
          (_.isEmpty(formDetails[checkKey]) ||
            formDetails[checkKey] === "undefined")
        ) {
          errors[checkKey] = "Please enter this field";
          setErrorData({
            // error: `Please Fill Out Required Fields`,
            description: `Please make sure to complete all mandatory questions before proceeding. Thank you!"`,
          });
          setUploadErrorPopup(true);
        }
      }
      if (el.attrType === "media") {
        el.items.map((data) => {
          let checkKey = el.property[data];
          if (
            el?.required &&
            (_.isEmpty(mediaSource[checkKey]) ||
              mediaSource[checkKey] === "undefined")
          ) {
            errors[checkKey] =
              el?.errorPlaceHolder || "Please enter this field";
            setErrorData({
              // error: `Please Fill Out Required Fields`,
              description: `Please make sure to complete all mandatory questions before proceeding. Thank you!"`,
            });
            setUploadErrorPopup(true);
          }
        });
      }
    });
  } catch (error) {
    const valid = true;
    return valid;
  }
};
